document.addEventListener('DOMContentLoaded', function () {
  const queryName = 'moments';
  const storageName = 'view_state';
  const params = new URLSearchParams(window.location.search);
  const queryValue = params.get(queryName);

  if (queryValue === 'true') {
    localStorage.setItem(storageName, 'active');
  }

  if (queryValue === 'false') {
    localStorage.removeItem(storageName);
  }

  const currentState = localStorage.getItem(storageName) === 'active';

  function setPinterestPreference() {
    document.querySelectorAll('img').forEach(function (image) {
      image.setAttribute('data-pin-nopin', 'true');
      image.setAttribute('nopin', 'nopin');
    });
  }

  setPinterestPreference();

  const sourceObserver = new MutationObserver(function () {
    setPinterestPreference();
  });

  sourceObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (!currentState) {
    document.body.classList.add('ui-layer');

    document.querySelectorAll('img').forEach(function (image) {
      image.classList.add('ui-layer');
    });

    document.addEventListener('contextmenu', function (event) {
      event.preventDefault();
    });

    document.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    document.addEventListener('selectstart', function (event) {
      event.preventDefault();
    });

    document.onkeydown = function (event) {
      const key = event.key.toLowerCase();
      const modifier = event.ctrlKey || event.metaKey;

      if (modifier && ['c', 'x', 'a', 's', 'u', 'p'].includes(key)) {
        event.preventDefault();
      }

      if (
        event.key === 'F12' ||
        (modifier && event.shiftKey && ['i', 'c', 'j'].includes(key))
      ) {
        event.preventDefault();
      }
    };
  }
});